













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SelectedChannel } from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { LogisticsNetwork } from '@/dto/';
@Component
export default class SVGLine extends Vue {
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: false }) public selectedChannel!: SelectedChannel;
    @Prop({ type: Boolean, required: true }) public selected!: boolean;
    @Prop({ type: Number, required: false }) public mode!: number;
    @Prop({ type: Object, required: false }) public handle!: any;

    private get calculateX1() {
        if (this.mode === null || this.mode === undefined) {
            return this.selectedChannel.point.mapObject.x;
        } else {
            return 0;
        }
    }

    private get calculateX2() {
        if (this.mode === null || this.mode === undefined) {
            const result = Formatters.prototype.svg_selected_channel_achor(this.selectedChannel, 4,
                                                            this.network.preferences.channel.maxDisplayCapacityWidth);
            return Formatters.prototype.get(result, 'x');
        } else {
            return this.handle.x;
        }
    }

    private get calculateY1() {
        if (this.mode === null || this.mode === undefined) {
            return this.selectedChannel.point.mapObject.y;
        } else {
            return 0;
        }
    }

    private get calculateY2() {
        if (this.mode === null || this.mode === undefined) {
            const result = Formatters.prototype.svg_selected_channel_achor(this.selectedChannel, 4,
                                                            this.network.preferences.channel.maxDisplayCapacityWidth);
            return Formatters.prototype.get(result, 'y');
        } else {
            return this.handle.y;
        }
    }

    private get calculateStrokeWidth() {
        if (this.mode === null || this.mode === undefined) {
            let value = 0;
            let value2 = 0;

            if (this.selected) {
                value = this.network.preferences.selection.minChannelSelectionWidth;
                value2 = this.network.preferences.selection.maxChannelSelectionWidth;
            } else {
                value = this.network.preferences.channel.minDisplayCapacityWidth;
                value2 = this.network.preferences.channel.maxDisplayCapacityWidth;
            }
            return Formatters.prototype.normalize(this.selectedChannel.point.flow,
                                                0,
                                                this.network.state.general.maxFlow,
                                                value,
                                                value2);
        } else {
            return this.network.preferences.selection.handleRadius;
        }
    }
}
